import {colors} from '../../../constants/colors'

export default {
    baseStyle: {
        page: {
            fontSize: '16px',
            flexWrap: 'wrap',
            marginTop: {xl: '52px'},
            marginBottom: {base: '40px', xl: '100px'},
            mx: 'auto',
            width: '100%',
            maxWidth: '1903px',
            minHeight: '100vh'
        },
        topBarSx: {
            '.left-scroll': {
                'overflow-x': 'auto',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none'
            },
            '.left-scroll::-webkit-scrollbar': {
                display: 'none'
            }
        },
        topBar: {
            width: {base: '100%', xl: '25%'},
            flexDirection: {base: 'row', xl: 'column'},
            borderBottom: {base: `1px solid ${colors.brightGray}`, xl: 'none'},
            paddingLeft: {base: '20px', xl: '30px'},
            overflowX: 'auto'
        },
        content: {
            padding: {base: '0 16px', xl: '0'},
            width: {base: '100%', xl: '59%'}
        },
        leftBtn: {
            whiteSpace: 'nowrap',
            marginRight: '16px',
            width: {xl: 'fit-content'},
            marginBottom: {xl: '24px'}
        },
        tab: {
            p: '0 2px',
            color: '#667085',
            marginRight: '16px',
            _selected: {color: `${colors.blueCol}`}
        },
        tabLink: {
            fontSize: '14px',
            fontWeight: '300',
            display: 'inline-block',
            padding: '11px 0',
            lineHeight: '24px'
        },
        richContentSx: {
            h4: {
                fontSize: {base: '20px', xl: '24px'},
                marginBottom: '20px',
                fontFamily: `'Roboto', sans-serif`,
                marginTop: '34px'
            },
            h3: {
                fontSize: {base: '20px', xl: '16px'},
                marginBottom: '20px',
                fontWeight: '300',
                fontFamily: `'Roboto', sans-serif`
            },
            p: {
                marginBottom: '20px',
                fontSize: {base: '14px', xl: '16px'}
            },
            ul: {
                paddingLeft: '20px',
                li: {
                    p: {
                        marginBottom: '0'
                    }
                }
            }
        },
        richContent: {
            color: `${colors.blueCol}`,
            fontWeight: '300'
        },
        contentHeading: {
            fontFamily: `'Raleway', sans-serif`,
            fontSize: {base: '24px', xl: '32px'},
            fontWeight: {base: '300', xl: '400'},
            lineHeight: '38px',
            marginBottom: {base: '20px', xl: '34px'},
            marginTop: {base: '20px', xl: '0'}
        }
    }
}
